import React from 'react';
import './news.css'
const News = () => {
  return (
    <div className="news-section">
      <div className="background-image"></div>
      <div className="content-wrapper py-16">
        <div className="left-poster"></div>
        <div className="right-content">
          {/* <h1 className='news-heading'>News & Updates</h1> */}
          
        
        </div>
      </div>
    </div>
  );
};

export default News;
